import { useCallback } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import { XMarkIcon } from '@heroicons/react/24/outline';

const stripePromise = loadStripe(
  (import.meta as unknown as { env: Record<string, string> }).env.VITE_STRIPE_PUBLISHABLE_KEY
);

interface CheckoutModalProps {
  clientSecret: string;
  onClose: () => void;
  onComplete: () => void;
}

export default function CheckoutModal({ clientSecret, onClose, onComplete }: CheckoutModalProps) {
  const handleComplete = useCallback(() => {
    onComplete();
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto bg-white rounded-2xl shadow-2xl mx-4">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-1.5 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
        >
          <XMarkIcon className="w-5 h-5 text-gray-500" />
        </button>

        {/* Stripe Embedded Checkout */}
        <div className="p-1">
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret, onComplete: handleComplete }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      </div>
    </div>
  );
}
